import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const USERNAME = 'username'
export const GROUP_NAME = 'Group Name'
export const CHANGE_ACCOUNT_TYPE = 'Change account type'
export const ACTIONS = 'Actions'
export const ENABLE = 'Enable'
export const DISABLE = 'Disable'
export const RESET = 'Reset'
export const CONFIRM_RESET = 'confirm reset'
export const NO = 'no'
export const YES = 'yes'
export const STATUS_CHANGE = 'status-change'

export default {
  [PORTUGUESE]: {
    [USERNAME]: 'Nome do usuário',
    [GROUP_NAME]: 'Nome do Grupo',
    [CHANGE_ACCOUNT_TYPE]: 'Alterar Tipo de Conta',
    [ACTIONS]: 'Ações',
    [RESET]: 'Redefinir',
    [CONFIRM_RESET]: 'Tem certeza de que deseja redefinir a senha do usuário',
    [NO]: 'Não',
    [YES]: 'Sim',
    [ENABLE]: 'Ativar',
    [DISABLE]: 'Desativar',
    [STATUS_CHANGE]: isDisabled => `Usuário ${isDisabled ? 'desativado' : 'ativado'}`,
  },

  [ENGLISH]: {
    [USERNAME]: 'Username',
    [GROUP_NAME]: 'Group Name',
    [CHANGE_ACCOUNT_TYPE]: 'Change Account Type',
    [ACTIONS]: 'Actions',
    [RESET]: 'Reset',
    [CONFIRM_RESET]: "Are you sure you want to reset the user's password",
    [NO]: 'No',
    [YES]: 'Yes',
    [ENABLE]: 'Enable',
    [DISABLE]: 'Disable',
    [STATUS_CHANGE]: isDisabled => `User is now ${isDisabled ? 'disabled' : 'enabled'}`,
  },

  [SPANISH]: {
    [USERNAME]: 'Nombre de usuario',
    [GROUP_NAME]: 'Nombre del Grupo',
    [CHANGE_ACCOUNT_TYPE]: 'Cambiar Tipo de Cuenta',
    [ACTIONS]: 'Acciones',
    [RESET]: 'Reiniciar',
    [CONFIRM_RESET]: 'Está seguro de que desea restablecer la contraseña del usuario',
    [NO]: 'No',
    [YES]: 'Sí',
    [ENABLE]: 'Activar',
    [DISABLE]: 'Desactivar',
    [STATUS_CHANGE]: isDisabled => `Usuario ${isDisabled ? 'desactivado' : 'activado'}`,
  },
}
